export default __webpack_public_path__ + "static/media/18.dbdbda05.jpeg";